import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isUserAndItsMorphIdentical } from '../utils/helpers/CommonHelper';

export function useIsUserAuthorOfEduCourse(lecturer) {
  const user = useSelector((s) => s.auth?.user);

  const isAuthor = useMemo(
    () => isUserAndItsMorphIdentical(user, lecturer),
    [lecturer, user],
  );

  return { isAuthor, user };
}
